import { type TrackedEvent, TrackedEventParam, type TrackedEventParams } from '@enmon/commons/lib/enmon';
import TagManager from 'react-gtm-module';

// GTM keeps a data layer key until it is pushed again, and the GA4 tag also fires on page views
const CLEARED_PARAMS = Object.fromEntries(Object.values(TrackedEventParam).map(param => [param, undefined]));

const clearParams = (): void => TagManager.dataLayer({ dataLayer: CLEARED_PARAMS });

/**
 * Sends a product event for the adoption overview in tools: GTM forwards `action.<name>` to GA with the parameters.
 * Parameters must not carry personal data or free text, as GA keeps them per user.
 */
export const trackEvent = (event: TrackedEvent, params: TrackedEventParams = {}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: `action.${event}`,
      ...params,
      // GTM calls this once the event's tags have run. The GA4 tag waits for the Google tag, so clearing right after
      // the push would drop the parameters; not clearing at all would put them on every later page view and event.
      eventCallback: clearParams,
    },
  });
};
